import { TaskList as Base } from "@corca/tiptap";

import { LineWrapperView } from "./utils/LineWrapperView";

export const TaskList = Base.extend({
  addNodeView() {
    return (props) => {
      return new LineWrapperView(props, {
        renderNodeAsChildIn: ["blockquote", "callout", "tableCell", "tableHeader"],
      });
    };
  },
});
